import React from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import Header from './Header';

class Happenings extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
        value: 0,
          result: null,
          error: false,
          topNews:[],
          topNewsy:[],
          topNewsz:[],
          happenings:[]
      }
    }

  componentDidMount() {

      axios.get('https://api.indianoilxpress.com/MobService.svc/happeningsall')
      .then(({data} )=> {
        const happenings = data.HappeningsSallResult
        this.setState({happenings});
      });
    }

  render() {
    return (
      <div>
        <Header />
        <br/>
        <br/>
        <br/>
        <div className="latest-new">
          <div className="head animated fadeInRight">
            <h5>Happenings</h5>
          </div>
          <div className="container animated fadeInUp">
            { this.state.happenings.map(happenings =>
            <div key={happenings.Newsid}>
            <div className="row" style={{ borderBottom : '1px solid', borderBottomColor: '#d0cfce'}}>
              <Link to={{ pathname: '/news', query:{newsId: happenings.Newsid } }} >
              <div className="col s5">
                <img src={happenings.newsimagepath} alt="IndianOil Xpress"/>
              </div>
              <div className="col s7">
                <h6><span>{happenings.Newstitle}</span></h6>
              </div>
              </Link>
            </div>
              
            </div>

            )}
          </div>
        </div>
        

        <div className="footer">
          <div className="container">
          <div className="copyright">
							<span>Copyright © IndianOilXpress</span><br/>
							<a href="https://www.facebook.com/IndianOilCorpLimited" target="_blank"><i class="fab fa-facebook-f"></i></a>
                <a href="https://twitter.com/indianOilcl" target="_blank"><i class="fab fa-twitter"></i></a>
                <a href="https://www.youtube.com/channel/UC5ho18VZHwEFSahW0Q_o-6g/feed" target="_blank"><i class="fab fa-youtube"></i></a>
				<a href="https://www.instagram.com/indianoilcorp" target="_blank"><i class="fab fa-instagram"></i></a>
				<a href="https://www.linkedin.com/company/indian-oil-corp-limited" target="_blank"><i class="fab fa-linkedin-in"></i></a>
				
						</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Happenings;


// WEBPACK FOOTER //
// ./src/Happenings.js